import angular from 'angular';
import uiRouter from 'angular-ui-router';
import racedayAddFormComponent from './racedayAddForm.component';

let racedayAddFormModule = angular.module('racedayAddForm', [
  uiRouter
])

.component('racedayAddForm', racedayAddFormComponent)

.name;

export default racedayAddFormModule;
